const links = document.querySelectorAll('a');

const init = function() {

  let pageHasVideo = false

  if ( links.length ) {

    // Check if the page has any youtube links
    links.forEach( link => {
      const href = !link.classList.contains( 'wp-block-social-link-anchor' ) ? link.getAttribute( 'href' ) : null
      if ( href && href.includes('youtube') ) {
        pageHasVideo = true
      }
    } );

    // If the page has youtube links...
    if ( pageHasVideo ) {

      // Add the youtube tag API script
      const tag = document.createElement( 'script' );
      tag.src = "https://www.youtube.com/iframe_api";
      const firstScriptTag = document.getElementsByTagName( 'script' )[0];
      firstScriptTag.parentNode.insertBefore( tag, firstScriptTag );
      

      // Add event listeners to the page youtube links
      links.forEach( link => {

        const href = !link.classList.contains( 'wp-block-social-link-anchor' ) ? link.getAttribute( 'href' ) : null

        if ( href && href.includes('youtube') ) {

          link.addEventListener( 'click', ( ev ) => {
            
            ev.preventDefault()
            const modal = document.getElementById( 'videoModal' )
            const dialog = new A11yDialog( modal )
            var   player

            // Credit: https://stackoverflow.com/questions/3452546/how-do-i-get-the-youtube-video-id-from-a-url
            function extractYouTubeID( url ){
              var regExp = /^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#&?]*).*/;
              var match = url.match(regExp);
              var id = (match&&match[7].length==11)? match[7] : false;
              return id
            }

            function onYouTubeIframeAPIReady() {
              player = new YT.Player( 'dialogVideoContainer', {
                height: '390',
                width: '640',
                videoId: extractYouTubeID(href),
                playerVars: {
                  'playsinline': 1
                },
                events: {
                  'onReady': onPlayerReady
                }
              });
            }

            function onPlayerReady( videoEvent ) {
              videoEvent.target.playVideo();
            }

            onYouTubeIframeAPIReady();

            dialog.show()

            dialog.on( 'hide', () => {
              player.destroy()
            })

            return false
            
          } )
        }

      } );

    }

  }

};

const api = {
	init: init
};

export default api;